export const brandConfig = {
  prod: {
    ackoByteBaseUrl: process.env.CARBON_URL,
    videoChannelId: '2',
  },
  dev: {
    ackoByteBaseUrl: process.env.CARBON_URL,
    videoChannelId: '9',
  },
  master: {
    ackoByteBaseUrl: process.env.CARBON_URL,
    videoChannelId: '9',
  },
  local: {
    ackoByteBaseUrl: process.env.CARBON_URL,
    videoChannelId: '9',
  },
}
